<h3 class="mt-3">
  <span>
    {{ "title.Grundbuch" | translate }}
  </span>
</h3>

<div>
  @if (art && (art === grundstueckArtEnum.STOCKWERK || art === grundstueckArtEnum.MITEIGENTUM)) {
    <cap-stammgrundstueck
      [grundstueckId]="_grundstueckId"
      [hasRight]="hasRight && hasRightAnzeigeEigentum"
      [tableFullWidth]="tableFullWidth"
      class="my-1">
    </cap-stammgrundstueck>
  }

  @if (art && art === grundstueckArtEnum.SDR) {
    <span>
      <cap-beschreibung-table-wrapper [tableFullWidth]="tableFullWidth" class="my-2">
        <span class="cap-table-wrapper-title" style="font-weight: bold">
          {{ "SelbststaendigUndDauerndeRechte" | translate }}
        </span>
        <cap-standardrecht-table
          [hasRight]="hasRight && dienstbarkeitenErsterfassungUebergeben"
          [listLoader]="sdrDienstbarkeitLoader"
          class="cap-table-wrapper-content">
        </cap-standardrecht-table>
      </cap-beschreibung-table-wrapper>
    </span>
  }

  @if (art && art === grundstueckArtEnum.STOCKWERK) {
    <cap-sonderrecht [grundstueckId]="_grundstueckId" [hasRight]="hasRight" [tableFullWidth]="tableFullWidth" class="my-2">
    </cap-sonderrecht>
  }

  <cap-dominierte-grundstuecke
    [grundstueckId]="_grundstueckId"
    [hasRight]="hasRight && hasPermissionDominierteGrundstuecke"
    [tableFullWidth]="tableFullWidth"
    class="my-2">
  </cap-dominierte-grundstuecke>

  @if (art && art === grundstueckArtEnum.FOLIO) {
    <cap-kuhrecht [grundstueckId]="_grundstueckId" [hasRight]="hasRight" [tableFullWidth]="tableFullWidth" class="my-2"></cap-kuhrecht>
  }

  @if (art && art === grundstueckArtEnum.FOLIO) {
    <cap-alpgrundstuecke [grundstueckId]="_grundstueckId" [hasRight]="hasRight" class="my-2"></cap-alpgrundstuecke>
  }

  <cap-grundstueck-bemerkung [grundstueckId]="_grundstueckId" [hasRight]="hasRight" class="my-2"></cap-grundstueck-bemerkung>
</div>
